import { CuttingState } from "./CuttingState.d";
import { ShipmentState } from "./ShipmentState.d";
import { ShipmentType } from "./ShipmentType.d";
import { UserType } from "./UserType.d";
import { CordwoodMeasurementType } from "./CordwoodMeasurementType.d";


import {ID, ListRequest} from "../../../types/global.d";
import {displayTime, displayDate, displayDateTime} from "../../../utils/formatDate";
import {OrderBy} from "../../../types/global.d";

// Interface for entity ContractorUsers


export interface ContractorUser {
    id: ID;

    
    email: string;

    
    name: string;

    
    description?: string;

    
    shipmentLogCode: string;

    
    shipmentLogCounter: string;

    
    shipmentCordwoodCode: string;

    
    shipmentCordwoodCounter: string;

    
    userType: UserType;

    
    contractorId: ID;

    
    userId: ID;

    
    scopeGroupId: ID;

    
    contractorScopeGroupId: ID;

    
    contractorUserScopeGroupId: ID;

    }




export interface CreateContractorUser {
    
    email: string;

    
    name: string;

    
    description?: string;

    
    shipmentLogCode: string;

    
    shipmentLogCounter: string;

    
    shipmentCordwoodCode: string;

    
    shipmentCordwoodCounter: string;

    
    userType: UserType;

    
    contractorId: ID;

    
    
    
    
    }


export interface UpdateContractorUser {
    
    
    name: string;

    
    description?: string;

    
    shipmentLogCode: string;

    
    shipmentLogCounter: string;

    
    shipmentCordwoodCode: string;

    
    shipmentCordwoodCounter: string;

    
    userType: UserType;

    
    
    
    
    
    }

export interface PresentationContractorUserRequest {
    list: ListRequest,
    filter: {
        email: string,
        emailOr: boolean,
        name: string,
        nameOr: boolean,
        contractorIdRefs?: ID[],
        userIdRefs?: ID[],
        orderBys: OrderBy[],
        caseSensitive: boolean,
    },
}

export class PrimaryContractorUser {
    id: string;


    constructor(
        id: ID,
        ) {
        this.id = id?.toString();
        }

    static fromEntity(entity: ContractorUser): PrimaryContractorUser | undefined {
        return entity ? new PrimaryContractorUser(
            entity.id,
        ) : undefined;
    }

    static fromId(id: ID
): PrimaryContractorUser {
        return new PrimaryContractorUser(
                id,
                );
    }
    
    static fromPath(path?: string): PrimaryContractorUser {
        let vals = path?.split('/');
        return new PrimaryContractorUser(
                   vals[0],
                );
    }

    static fromQuery(value?: string): number | undefined {
        return value ? value : undefined
    }

    toPath(): string {
        let ids = [
            this.id,
            ];
        return ids.join('/');
    }

    static toQueryParams(ids: PrimaryContractorUser[]): string {
        return '?ids=' + ids.map(id => id.id).join('&ids=');
    }
}

export function toString(entity?: ContractorUser): string {
    let fields = entity ? [
    entity.email,
            entity.name,
            ] : [];
    return fields.filter(item => item).join(' | ');
}

export class UpdateEntityContractorUser {
    id: PrimaryContractorUser;
    data: UpdateContractorUser;


    constructor(id: PrimaryContractorUser, data: UpdateContractorUser) {
        this.id = id;
        this.data = data;
    }
}
